import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleCard from "@/components/feature/ArticleCard";
import CategoryTabs from "@/components/feature/CategoryTabs";
import Breadcrumb from "@/components/base/Breadcrumb";
import SchemaOrg from "@/components/base/SchemaOrg";
import { articles, categories } from "@/mocks/siteData";

export default function Category() {
  const { slug } = useParams<{ slug: string }>();

  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <div className="pt-20 pb-12 px-6 md:px-10 text-center">
          <h1 className="text-2xl font-bold text-foreground-950">分类未找到</h1>
          <Link to="/" className="text-accent-500 mt-4 inline-block">返回首页</Link>
        </div>
        <Footer />
      </div>
    );
  }

  const categoryArticles = articles.filter((a) => a.category === category.id);

  return (
    <>
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${category.name} - ${"白丝足交完全指南"}`,
          description: category.description,
          url: `https://baisi-guide.com/category/${category.slug}`,
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <div className="pt-20 pb-12 px-6 md:px-10">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: category.name },
              ]}
            />

            <div className="relative w-full h-[280px] md:h-[360px] rounded-lg overflow-hidden mb-8">
              <img
                src={category.imageUrl}
                alt={category.name}
                title={category.name}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-black/30"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <h1 className="text-2xl md:text-4xl font-bold text-white mb-2" style={{ fontFamily: "var(--font-heading)" }}>
                  {category.name}
                </h1>
                <p className="text-sm md:text-base text-white/80 max-w-2xl">
                  {category.description}
                </p>
              </div>
            </div>

            <div className="mb-8">
              <CategoryTabs activeCategory={category.id} />
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {categoryArticles.map((article) => (
                  <ArticleCard
                    key={article.id}
                    slug={article.slug}
                    title={article.title}
                    excerpt={article.excerpt}
                    category={article.category}
                    imageUrl={article.imageUrl}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <p className="text-foreground-600">该分类下暂无文章</p>
              </div>
            )}
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}